import { render, staticRenderFns } from "./Bulb.vue?vue&type=template&id=246013ec&scoped=true&"
import script from "./Bulb.vue?vue&type=script&lang=js&"
export * from "./Bulb.vue?vue&type=script&lang=js&"
import style0 from "./Bulb.vue?vue&type=style&index=0&id=246013ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246013ec",
  null
  
)

export default component.exports